Unit BranchGroupManager;

Interface

Uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  WebForm.Core,
  WEBLib.StdCtrls,
  Vcl.Controls;

Type
  TBranchGroupManagerForm = Class(TCoreWebForm)
    EmptyStateLabel: TLabel;
    AddGroupBtn: TButton;
    Procedure WebFormCreate(Sender: TObject);
    Procedure WebFormShow(Sender: TObject);
    Procedure WebFormDestroy(Sender: TObject);
    Procedure AddGroupBtnClick(Sender: TObject);
    Procedure FirePendingBranchGroupAction;
    Procedure RenameCustomGroup(Const AGroupId: String);
    Procedure DeleteCustomGroup(Const AGroupId: String);
  Private
    FActionInProgress: Boolean;
    [Async]
    Procedure LoadTree; async;
    Procedure BindAdminBridge;
    Procedure QueueActionAndFire(Const AAction: String);
    [Async]
    Procedure ProcessPendingAction; async;
    Function SelectedGroupId: String;
    Function PromptInput(Const ACaption, ADefault: String): String;
    Procedure FixBranchGroupLayout;
  Public
  protected procedure LoadDFMValues; override; End;

Var
  BranchGroupManagerForm: TBranchGroupManagerForm;

Implementation

{$R *.dfm}

Uses
  XData.Web.Client,
  MainDataModule,
  CSY.Enumerations,
  SMX.XData.Utils;

{ TBranchGroupManagerForm }

Procedure TBranchGroupManagerForm.WebFormCreate(Sender: TObject);
Begin
  ElementClassName := 'branch-group-manager-page';
  Inherited;
  BindAdminBridge;
End;

Procedure TBranchGroupManagerForm.WebFormShow(Sender: TObject);
Begin
  FixBranchGroupLayout;
  LoadTree;
End;

Procedure TBranchGroupManagerForm.WebFormDestroy(Sender: TObject);
Begin
  asm
    if (window.SMX && window.SMX.teardownBranchGroupAdmin) {
      window.SMX.teardownBranchGroupAdmin();
    }
  end;
  Inherited;
End;

Procedure TBranchGroupManagerForm.FixBranchGroupLayout;
Begin
  asm
    function stripBranchGroupChrome(start) {
      var node = start;
      while (node && node.id !== 'MainPanel') {
        node.style.overflowX = 'hidden';
        node.style.maxWidth = '100%';
        if (node.classList && node.classList.contains('SMXWebBranchGroupManagement')) {
          node.style.width = '100%';
        }
        node.style.height = 'auto';
        node.style.minHeight = '0';
        node.style.border = 'none';
        node.style.outline = 'none';
        node = node.parentElement;
      }
    }

    var card = document.querySelector('.SMXWebBranchGroupManagement');
    if (card) {
      stripBranchGroupChrome(card);
    }
    var formRoot = document.querySelector('.branch-group-manager-page');
    if (formRoot) {
      stripBranchGroupChrome(formRoot);
    }

    if (window.SMX && window.SMX.fixBranchGroupLayout) {
      window.SMX.fixBranchGroupLayout();
    }

    var ghostBtn = document.getElementById('BranchGroupActionBtn');
    if (ghostBtn && ghostBtn.parentElement) {
      ghostBtn.parentElement.removeChild(ghostBtn);
    }
  end;
End;

Procedure TBranchGroupManagerForm.BindAdminBridge;
Begin
  asm
    window.SMX = window.SMX || {};
    window.SMX._branchGroupAdminFire = (function(form) {
      return function() {
        form.FirePendingBranchGroupAction();
      };
    })(this);
    window.SMX._branchGroupRenameGroup = (function(form) {
      return function(groupId) {
        form.RenameCustomGroup(String(groupId || ''));
      };
    })(this);
    window.SMX._branchGroupDeleteGroup = (function(form) {
      return function(groupId) {
        form.DeleteCustomGroup(String(groupId || ''));
      };
    })(this);
  end;
End;

Function TBranchGroupManagerForm.SelectedGroupId: String;
Begin
  asm
    Result = (window.SMX && window.SMX._branchGroupSelectedId) ? String(window.SMX._branchGroupSelectedId) : '';
  end;
End;

Function TBranchGroupManagerForm.PromptInput(Const ACaption, ADefault: String): String;
Begin
  Result := Trim(InputBox(ACaption, 'Name:', ADefault));
End;

Procedure TBranchGroupManagerForm.QueueActionAndFire(Const AAction: String);
Begin
  asm
    window.SMX._branchGroupPendingAction = AAction;
  end;
  FirePendingBranchGroupAction;
End;

Procedure TBranchGroupManagerForm.FirePendingBranchGroupAction;
Begin
  If FActionInProgress Then
  Begin
    asm
      (function(form) {
        window.setTimeout(function() {
          form.FirePendingBranchGroupAction();
        }, 50);
      })(this);
    end;
    Exit;
  End;
  ProcessPendingAction;
End;

[Async]
Procedure TBranchGroupManagerForm.ProcessPendingAction; async;
Var
  lAction: String;
  lParts: TArray<String>;
  lGroupId: String;
  lBranchId: String;
  lTargetGroupId: String;
  lSourceGroupId: String;
  lParentGroupId: String;
  lSortOrder: Integer;
  lStatus: String;
  lEnabled: Boolean;
  lName: String;
Begin
  If FActionInProgress Then
    Exit;
  FActionInProgress := True;
  Try
    asm
      lAction = window.SMX._branchGroupPendingAction || '';
      window.SMX._branchGroupPendingAction = '';
    end;
    If lAction = '' Then
      Exit;

    lParts := lAction.Split(['|']);
    If Length(lParts) = 0 Then
      Exit;

    If lParts[0] = 'toggleGroup' Then
    Begin
      lGroupId := lParts[1];
      lEnabled := SameText(lParts[2], '1');
      If lEnabled Then
        lStatus := Branch_Group_Status[TBranchGroupStatus.Selectable]
      Else
        lStatus := Branch_Group_Status[TBranchGroupStatus.NotSelectable];
      await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync('IBranchService.SetBranchGroupStatus',
        [lGroupId, lStatus]));
      LoadTree;
    End
    Else If lParts[0] = 'toggleBranch' Then
    Begin
      lGroupId := lParts[1];
      lBranchId := lParts[2];
      lEnabled := SameText(lParts[3], '1');
      await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync('IBranchService.SetBranchEnabled',
        [lGroupId, lBranchId, lEnabled]));
      LoadTree;
    End
    Else If lParts[0] = 'moveBranch' Then
    Begin
      lBranchId := lParts[1];
      lTargetGroupId := lParts[2];
      lSourceGroupId := lParts[3];
      If lSourceGroupId <> '' Then
        await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync('IBranchService.RemoveBranchFromCustomGroup',
          [lSourceGroupId, lBranchId]));
      If lTargetGroupId <> '' Then
        await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync('IBranchService.AddBranchToCustomGroup',
          [lTargetGroupId, lBranchId]));
      LoadTree;
    End
    Else If lParts[0] = 'moveGroup' Then
    Begin
      lGroupId := lParts[1];
      lParentGroupId := lParts[2];
      lSortOrder := StrToIntDef(lParts[3], -1);
      await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync('IBranchService.MoveCustomBranchGroup',
        [lGroupId, lParentGroupId, lSortOrder]));
      LoadTree;
    End
    Else If lParts[0] = 'createGroup' Then
    Begin
      lParentGroupId := lParts[1];
      lName := lParts[2];
      await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync('IBranchService.CreateCustomBranchGroup',
        [lParentGroupId, lName]));
      LoadTree;
    End
    Else If lParts[0] = 'deleteGroup' Then
    Begin
      lGroupId := lParts[1];
      Try
        await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync('IBranchService.DeleteCustomBranchGroup',
          [lGroupId]));
        await(LoadTree);
      Except
        DisplayMessage('Could not delete the custom group. It may have already been removed.', TMsgDlgType.mtWarning);
        await(LoadTree);
      End;
    End
    Else If lParts[0] = 'renameGroup' Then
    Begin
      lGroupId := lParts[1];
      lName := lParts[2];
      await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync('IBranchService.RenameCustomBranchGroup',
        [lGroupId, lName]));
      LoadTree;
    End;
  Finally
    FActionInProgress := False;
  End;
End;

Procedure TBranchGroupManagerForm.RenameCustomGroup(Const AGroupId: String);
Var
  lName: String;
  lCurrentName: String;
Begin
  If Trim(AGroupId) = '' Then
    Exit;
  asm
    lCurrentName = '';
    var node = document.querySelector('.bg-node-custom-item[data-group-id="' + AGroupId + '"] .bg-node-title');
    if (node) {
      lCurrentName = String(node.textContent || '').trim();
    }
  end;
  lName := PromptInput('Rename custom group', lCurrentName);
  If lName = '' Then
    Exit;
  QueueActionAndFire('renameGroup|' + AGroupId + '|' + lName);
End;

Procedure TBranchGroupManagerForm.DeleteCustomGroup(Const AGroupId: String);
Begin
  If Trim(AGroupId) = '' Then
    Exit;
  If ConfirmationRequest('Delete this custom group and its nested custom groups?', TMsgDlgType.mtConfirmation,
    [mbYes, mbNo]) <> mrYes Then
    Exit;
  QueueActionAndFire('deleteGroup|' + AGroupId);
End;

Procedure TBranchGroupManagerForm.AddGroupBtnClick(Sender: TObject);
Var
  lParentId: String;
  lName: String;
Begin
  lParentId := SelectedGroupId;
  lName := PromptInput('Add custom group', 'Custom Group');
  If lName = '' Then
    Exit;
  QueueActionAndFire('createGroup|' + lParentId + '|' + lName);
End;

[Async]
Procedure TBranchGroupManagerForm.LoadTree; async;
Const
  svc_name = 'IBranchService.GetBranchAdminTree';
Var
  lRetval: TXDataClientResponse;
  lTreeJson: String;
  lLoadFailed: Boolean;
Begin
  lLoadFailed := False;
  lTreeJson := '{"Tree":[],"AvailableBranches":[]}';
  Try
    lRetval := await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync(svc_name, []));
    lTreeJson := Trim(TsmxXDataUtils.AsString(lRetval));
    If lTreeJson = '' Then
      lTreeJson := '{"Tree":[],"AvailableBranches":[]}';
  Except
    lLoadFailed := True;
  End;
  asm
    function renderBranchGroupTree(jsonText, loadFailed) {
      if (window.SMX && window.SMX.fixBranchGroupLayout) {
        window.SMX.fixBranchGroupLayout();
      }
      if (window.SMX && window.SMX.renderBranchGroupAdmin) {
        window.SMX.renderBranchGroupAdmin(jsonText);
      } else {
        var help = document.querySelector('.SMXWebBranchGroupManagement .branch-group-admin-help');
        if (help) {
          help.textContent = 'Branch group script failed to load. Hard-refresh the browser (Ctrl+F5).';
        }
      }
      if (loadFailed) {
        var helpErr = document.querySelector('.SMXWebBranchGroupManagement .branch-group-admin-help');
        if (helpErr) {
          helpErr.textContent = 'Could not load branch groups from the server. Check CSYDashboardServer is running on port 2020.';
        }
      }
    }
    renderBranchGroupTree(lTreeJson, lLoadFailed);
  end;
End;

procedure TBranchGroupManagerForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  EmptyStateLabel := TLabel.Create('BranchGroupEmptyState');
  AddGroupBtn := TButton.Create('BranchGroupAddBtn');

  EmptyStateLabel.BeforeLoadDFMValues;
  AddGroupBtn.BeforeLoadDFMValues;
  try
    Name := 'BranchGroupManagerForm';
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    SetEvent(Self, 'OnDestroy', 'WebFormDestroy');
    EmptyStateLabel.SetParentComponent(Self);
    EmptyStateLabel.Name := 'EmptyStateLabel';
    EmptyStateLabel.Left := 32;
    EmptyStateLabel.Top := 80;
    EmptyStateLabel.Width := 480;
    EmptyStateLabel.Height := 24;
    EmptyStateLabel.HeightPercent := 100.000000000000000000;
    EmptyStateLabel.WidthPercent := 100.000000000000000000;
    EmptyStateLabel.Caption := 'No branch groups found for this tenant.';
    EmptyStateLabel.ElementClassName := 'text-muted branch-group-empty';
    EmptyStateLabel.ElementPosition := epIgnore;
    EmptyStateLabel.Visible := False;
    AddGroupBtn.SetParentComponent(Self);
    AddGroupBtn.Name := 'AddGroupBtn';
    AddGroupBtn.Left := 24;
    AddGroupBtn.Top := 24;
    AddGroupBtn.Width := 140;
    AddGroupBtn.Height := 28;
    AddGroupBtn.Caption := 'Add custom group';
    AddGroupBtn.ElementClassName := 'btn btn-sm btn-outline-primary';
    AddGroupBtn.ElementPosition := epIgnore;
    AddGroupBtn.HeightStyle := ssAuto;
    AddGroupBtn.WidthStyle := ssAuto;
    SetEvent(AddGroupBtn, Self, 'OnClick', 'AddGroupBtnClick');
  finally
    EmptyStateLabel.AfterLoadDFMValues;
    AddGroupBtn.AfterLoadDFMValues;
  end;
end;

End.
